export class ProdutoFidelidade{
  id: number;
  produto: string;
  pontos: number;
  prazoEntrega: number;
  ativo: boolean;
  foto: any;
  fotoBase64: string;
  imagem$: Promise<any>;
  buscouImagem: boolean;
}
